import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import Button from '@polyai/ui/components/atoms/Button';

import FormProvider, {
  FormTextInput,
} from '../../../components/molecules/Form';
import { OPENTABLE_NEW_AGENT_UI_COPY } from '../OpenTableNewAgent.uiCopy';
import { type WebsiteUrlFormData, websiteUrlSchema } from '../types';

interface WebsiteUrlFormProps {
  onSubmit: (data: WebsiteUrlFormData) => void;
  isSubmitting: boolean;
  websiteUrl?: string;
}

export default function WebsiteUrlForm({
  onSubmit,
  isSubmitting,
  websiteUrl = '',
}: WebsiteUrlFormProps) {
  const methods = useForm<WebsiteUrlFormData>({
    resolver: zodResolver(websiteUrlSchema),
    defaultValues: {
      websiteUrl: websiteUrl,
    },
  });

  return (
    <div className="flex flex-col gap-sm4">
      <div className="flex flex-col gap-sm2">
        <h2 className="text-header-large font-semibold text-primary leading-tight">
          {OPENTABLE_NEW_AGENT_UI_COPY.websiteUrl.title}{' '}
          <span className="text-helper">(Recommended)</span>
        </h2>
        <h3 className="text-body-regular text-secondary">
          {OPENTABLE_NEW_AGENT_UI_COPY.websiteUrl.description}
        </h3>
      </div>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <FormTextInput
          controlKey="websiteUrl"
          label="Website URL"
          placeholder={OPENTABLE_NEW_AGENT_UI_COPY.websiteUrl.placeholder}
          type="url"
        />
        <Button
          className="mt-sm4"
          disabled={isSubmitting}
          label="Continue"
          type="submit"
          variant="PRIMARY"
          fullWidth
        />
      </FormProvider>
    </div>
  );
}
